import { render, staticRenderFns } from "./BrowserPreview.vue?vue&type=template&id=674ac181&scoped=true&"
import script from "./BrowserPreview.vue?vue&type=script&lang=js&"
export * from "./BrowserPreview.vue?vue&type=script&lang=js&"
import style0 from "./BrowserPreview.vue?vue&type=style&index=0&id=674ac181&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ac181",
  null
  
)

export default component.exports